import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53d9cbf9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field-container" }
const _hoisted_2 = {
  key: 0,
  class: "field-name",
  for: "input-field-text"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass({
            'drop-icon-wrapper': true,
          })
}
const _hoisted_5 = { class: "calendar-header" }
const _hoisted_6 = { class: "calendar-detail" }
const _hoisted_7 = { class: "calendar-year" }
const _hoisted_8 = { class: "calendar-wd-month" }
const _hoisted_9 = { class: "calendar-day" }
const _hoisted_10 = {
  key: 0,
  class: "calendar-main"
}
const _hoisted_11 = { class: "calendar-nav calendar-show-years" }
const _hoisted_12 = { class: "calendar-month-year" }
const _hoisted_13 = { class: "nav-month" }
const _hoisted_14 = { class: "ten-years" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "calendar-main"
}
const _hoisted_17 = { class: "calendar-nav calendar-show-months" }
const _hoisted_18 = { class: "nav-month" }
const _hoisted_19 = { class: "twelve-months" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 2,
  class: "calendar-main"
}
const _hoisted_22 = { class: "calendar-nav" }
const _hoisted_23 = { class: "nav-month" }
const _hoisted_24 = { class: "six-weeks" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "week-days" }, [
  /*#__PURE__*/_createElementVNode("span", null, " D "),
  /*#__PURE__*/_createElementVNode("span", null, " S "),
  /*#__PURE__*/_createElementVNode("span", null, " T "),
  /*#__PURE__*/_createElementVNode("span", null, " Q "),
  /*#__PURE__*/_createElementVNode("span", null, " Q "),
  /*#__PURE__*/_createElementVNode("span", null, " S "),
  /*#__PURE__*/_createElementVNode("span", null, " S ")
], -1))
const _hoisted_26 = { class: "four-two" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "advise" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'form-group': true,
      'input-is-invalid': !!_ctx.validation_message,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({
          'input-field': true,
          'input-not-empty': _ctx.visible || _ctx.date_text,
          'input-disabled': _ctx.disabled,
        }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible ? _ctx.hide() : _ctx.show()))
      }, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          type: "text",
          ref: "input_text",
          name: "input-field-text",
          class: _normalizeClass({
            'show-time': true,
          }),
          value: _ctx.date_text,
          autocomplete: "off",
          readonly: "true",
          tabindex: "-1"
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            class: "drop-icon",
            icon: ['fa', 'calendar-alt']
          })
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({
          'calendar-picker': true,
          'show-calendar-picker': _ctx.visible,
        })
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.current_date.getFullYear()), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.current_wd_text) + ", " + _toDisplayString(_ctx.current_month_text), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.current_date.getDate()), 1)
          ])
        ]),
        (_ctx.show_years)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.decade_start) + " - " + _toDisplayString(_ctx.decade_end), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", {
                    class: "noselect prev-next",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (
                  (_ctx.decade_end = _ctx.decade_start - 1),
                    (_ctx.decade_start -= 10),
                    _ctx.getTenYears()
                ))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
                  ]),
                  _createElementVNode("span", {
                    class: "noselect prev-next",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (
                  (_ctx.decade_start = _ctx.decade_end), (_ctx.decade_end += 10), _ctx.getTenYears()
                ))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "chevron-right" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ten_years, (y) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["noselect select-date", {
                'is-selected': _ctx.offset_date.getFullYear() == y,
              }]),
                    key: y,
                    onClick: ($event: any) => (_ctx.setDateOffsetYear(y))
                  }, _toDisplayString(y), 11, _hoisted_15))
                }), 128))
              ])
            ]))
          : (_ctx.show_months)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", {
                    class: "calendar-month-year",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getTenYears(), (_ctx.show_years = true)))
                  }, _toDisplayString(_ctx.offset_date.getFullYear()), 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", {
                      class: "noselect prev-next",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setOffsetDateYear(-1)))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
                    ]),
                    _createElementVNode("span", {
                      class: "noselect prev-next",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setOffsetDateYear(1)))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "chevron-right" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (m) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: _normalizeClass(["noselect select-date", {
                'is-selected': _ctx.offset_date.getMonth() == m.i,
              }]),
                      key: m.i,
                      onClick: ($event: any) => (_ctx.setDateOffsetMonth(m.i))
                    }, _toDisplayString(m.nome), 11, _hoisted_20))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", {
                    class: "calendar-month-year",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.show_months = true))
                  }, _toDisplayString(_ctx.offset_month_year), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", {
                      class: "noselect prev-next",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setOffsetDateMonth(-1)))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
                    ]),
                    _createElementVNode("span", {
                      class: "noselect go-today",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setNewCurrentDate(new Date())))
                    }, "Hoje"),
                    _createElementVNode("span", {
                      class: "noselect prev-next",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setOffsetDateMonth(1)))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "chevron-right" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.four_two, (d) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: _normalizeClass(["noselect select-date", {
                  'is-selected': d.isSelected,
                  'out-month': d.outMonth,
                  'is-today': d.isToday,
                }]),
                        key: d.day + '/' + d.month + '/' + d.year,
                        onClick: ($event: any) => (_ctx.setNewCurrentDate(d.date))
                      }, _toDisplayString(d.date.getDate()), 11, _hoisted_27))
                    }), 128))
                  ])
                ])
              ]))
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_28, [
      (_ctx.validation_message)
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: "exclamation-circle"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(_ctx.validation_message), 1)
    ])
  ], 2))
}